import { useEffect } from 'react'

export function useAiAskBarDictationEffects({
  micError,
  setIsDictating,
  isDictating,
  dictationCancelRef,
}) {
  useEffect(() => {
    if (!micError) return
    window.alert(micError)
    queueMicrotask(() => setIsDictating(false))
  }, [micError, setIsDictating])

  useEffect(() => {
    if (!isDictating) return
    dictationCancelRef.current?.focus()
  }, [isDictating, dictationCancelRef])
}
